import React from 'react';

const ArrowIcon = () => (
  <svg width="12" height="6" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.0608 0.139359C11.2856 -0.0610059 11.6299 -0.0434143 11.832 0.179861C12.0334 0.403579 12.0153 0.748872 11.7915 0.950021L6.33556 5.86016C6.12674 6.04661 5.81359 6.04661 5.6046 5.86016L0.180411 0.950771C-0.0433075 0.749418 -0.0614451 0.404261 0.139908 0.180611C0.353705 -0.0552441 0.698692 -0.0506416 0.911091 0.140109L5.97076 4.72043L11.0608 0.139359Z"
      fill="currentColor"
    />
  </svg>
);

export default ArrowIcon;
